import { render, staticRenderFns } from "./form-grupo-alvo.vue?vue&type=template&id=9a69496a&"
import script from "./form-grupo-alvo.vue?vue&type=script&lang=js&"
export * from "./form-grupo-alvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports